var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    fill: "#E64B38",
    height: "16px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.7,1h1.9c0.3,0,0.5-0.2,0.5-0.5S3.9,0,3.6,0H0.5c0,0,0,0,0,0C0.4,0,0.4,0,0.3,0c-0.1,0-0.1,0.1-0.1,0.1 c0,0,0,0,0,0c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1c0,0.1,0,0.1,0,0.2v3.1c0,0.3,0.2,0.5,0.5,0.5S1,3.9,1,3.6V1.7L5.3,6 c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3-0.1c0.2-0.2,0.2-0.5,0-0.7L1.7,1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,0.3c0-0.1-0.1-0.2-0.3-0.3c-0.1,0-0.1,0-0.2,0h-3.1c-0.3,0-0.5,0.2-0.5,0.5S12.1,1,12.4,1h1.9L10,5.3 C9.8,5.5,9.8,5.8,10,6c0.1,0.1,0.2,0.1,0.3,0.1s0.2,0,0.3-0.1L15,1.7v1.9c0,0.3,0.2,0.5,0.5,0.5S16,3.9,16,3.6V0.5 C16,0.4,16,0.4,16,0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5,11.9c-0.3,0-0.5,0.2-0.5,0.5v1.9L10.7,10c-0.2-0.2-0.5-0.2-0.7,0c-0.2,0.2-0.2,0.5,0,0.7l4.4,4.4h-1.9 c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5h3.1c0.1,0,0.1,0,0.2,0c0.1,0,0.2-0.1,0.3-0.3c0-0.1,0-0.1,0-0.2v-3.1 C16,12.1,15.8,11.9,15.5,11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3,10L1,14.3v-1.9c0-0.3-0.2-0.5-0.5-0.5S0,12.1,0,12.4v3.1c0,0.1,0,0.1,0,0.2c0,0.1,0.1,0.1,0.1,0.1 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0.1,0.1,0.1c0.1,0,0.1,0,0.2,0h3.1c0.3,0,0.5-0.2,0.5-0.5S3.9,15,3.6,15H1.7L6,10.7 c0.2-0.2,0.2-0.5,0-0.7C5.8,9.8,5.5,9.8,5.3,10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.58dc06fa93c91a54431ba302b97ea4de.svg";
export { ForwardRef as ReactComponent };